import { FC, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

interface IProps {
  file: any;
  setFile: Function;
  isAddon?: boolean;
  accept?: string;

  onChange?: (e:any) => void;
}

const Block = styled.a`
    display: flex;
    align-items: center;
    color: black;
    gap: 6px;
    
    &:hover {
        color: #1f1f1f;
    }

    .upload-filename {
      border-radius: 4px;
      border: solid 1px #dcdcdc;
      width: 200px;
      line-height: 28px;
      height: 28px;
      padding: 0 10px;
      color: #999;
    }

    .upload-input {
        display: none;
    }

    input {
        border: 1px solid #ccc;
        background: #f2f2f2;
        padding-left: 5px;
    }
`;

const AddonBlock = styled.div`
  color: black;

  .upload-filename {
    border-radius: 4px;
    border: solid 1px #dcdcdc;
    width: 200px;
    line-height: 28px;
    height: 28px;
    padding: 0 10px;
    color: #999;
  }

  input {
    border: 1px solid #ccc;
    background: #f2f2f2;
    padding-left: 5px;
  }

  .upload-label {
    position: relative;
    top: 1px;
    height: 30px;
    line-height: 30px;
  }

  .upload-input {
    display: none;
  }

  & > label {
    margin: 0;
  }
`;

const MintLabel = styled.label`
    border-radius: 4px;
    border: 1px solid #5dbecd;
    width: 69px;
    height: 28px;
    color: #5dbecd;
    font-size: 12px;
    padding: 7px 15px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0;
    
    &:hover {
        color: #54abb9;
        border: 1px solid #54abb9;
    }
`

let fileIndex = 0;

const FileUpload: FC<IProps> = ({ file, setFile, isAddon = false, accept, onChange }) => {
  fileIndex++;
  const { t } = useTranslation();
  const fileRef = useRef<HTMLInputElement | null>(null);

  return (
    <>
      {isAddon ? (
        <AddonBlock className="input-group">
          <input
            className="upload-filename"
            value={file?.name || t('common.file.notFound')}
            disabled={true}
            onClick={() => {
              fileRef.current?.click();
            }}
          />
          <div className="comm-btn__area ml-2">
            <button
              className="btn-basic small mint-line"
              onClick={() => {
                fileRef.current?.click();
              }}
            >
              {t('common.button.upload')}
            </button>
            <input
              ref={fileRef}
              type="file"
              id={`uploadInput-${fileIndex}`}
              className="upload-input"
              onChange={onChange ? onChange : (e) => {
                if (e.target.files) setFile(e.target.files[0]);
              }}
              accept={
                accept ||
                '.hwp, .hwpx, .doc, .docx, .xls, .xlsx, .ppt, .pptx, .pdf, .txt, .png, .bmp, .jpg, .jpeg, .gif, .zip'
              }
            />
          </div>
        </AddonBlock>
      ) : (
        <Block>
          <input
            className="upload-filename"
            value={file?.name || t('common.file.notFound')}
            disabled={true}
          />
          <MintLabel
            htmlFor={`uploadInput-${fileIndex}`}
          >
            {t('common.button.upload')}
          </MintLabel>
          <input
            type="file"
            id={`uploadInput-${fileIndex}`}
            className="upload-input"
            onChange={onChange ? onChange : (e) => {
              if (e.target.files) setFile(e.target.files[0]);
            }}
            accept={
              accept ||
              '.hwp, .hwpx, .doc, .docx, .xls, .xlsx, .ppt, .pptx, .pdf, .txt, .png, .bmp, .jpg, .jpeg, .gif, .zip'
            }
          />
        </Block>
      )}
    </>
  );
};

export default FileUpload;
